import { SubmissionError } from 'redux-form';
import { COMPATIBILITIES_REQUIRED_FIELDS, REQUIRED_FIELDS, REQUIRED_WITH_AUTOPARK_FIELDS } from './constants';
import { goToElement } from '../../../../utils/goToElement';

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (key.includes('compatibilities') && key !== 'compatibilities') {
			const arr = key.split('.');

			if (!prev.compatibilities) {
				prev.compatibilities = {};
			}

			prev.compatibilities = {
				...prev.compatibilities,
				[arr[1]]: {
					...(prev.compatibilities[arr[1]] || {}),
					[arr[2]]: !arr[3] ? error : { error },
				},
			};
		}

		prev[key] = error;

		return prev;
	}, {});
};

const validateCompatibilities = (values, key, index, fields) => {
	fields.forEach(field => {
		if (!values?.compatibilities?.[index]?.[field]) {
			const error = { compatibilities: [] };
			error.compatibilities[index] = { [field]: 'Заполните это поле' };
			goToElement(`${key}.${field}`);
			throw new SubmissionError(error);
		}
	});
};

export const validate = values => {
	const requiredFields = values.is_autopark ? REQUIRED_WITH_AUTOPARK_FIELDS : REQUIRED_FIELDS;

	requiredFields.forEach(key => {
		if (key === 'compatibilities') {
			Object.keys(values?.compatibilities).forEach(idx => {
				validateCompatibilities(values, `compatibilities[${idx}]`, idx, COMPATIBILITIES_REQUIRED_FIELDS);
			});
		}

		if (key === 'autopark_ids') {
			if (
				values?.[key] === undefined ||
				values?.[key] === '' ||
				values?.[key] === null ||
				values?.[key].length === 0
			) {
				goToElement(key);
				throw new SubmissionError({ [key]: 'Заполните это поле' });
			}
		}

		if (!values?.[key]) {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
